import { defineComponent as _defineComponent } from 'vue'
import VPreLoader from "@/components/vPreLoader.vue";

type vLabelPreviewImageProps = {
  isLoading: boolean;
  shouldDisplayLabel: boolean;
  labelPreviewData: {
    isBase64: boolean;
    resource: string;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'vLabelPreviewImage',
  props: {
    isLoading: { type: Boolean, default: false },
    shouldDisplayLabel: { type: Boolean },
    labelPreviewData: null
  },
  setup(__props: any) {

const props = __props as { isLoading: boolean, shouldDisplayLabel: boolean, labelPreviewData: {
    isBase64: boolean;
    resource: string;
  } };



return { __sfc: true,props, VPreLoader }
}

})